import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import EditingDocument from '@app/store/editingDocuments/EditingDocument';

/**
 * POST 편집 문서들 삭제
 */
export function deleteEditingDocuments(
  workspaceId: string,
  { editingDocumentIds }: { editingDocumentIds: string[] }
) {
  return requestApi({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents/delete`),
    method: 'POST',
    data: {
      editingDocumentIds,
    },
    credentials: true,
  });
}

interface EditingDocumentsResponse {
  count: number;
  editingDocuments: EditingDocument[];
}

/**
 * GET 편집 문서들 조회
 */
export function getEditingDocuments(
  workspaceId: string,
  {
    limit,
    offset,
    searchKeyword,
    memberId,
  }: {
    limit: number;
    offset: number;
    searchKeyword: string;
    memberId: string | null;
  }
): Promise<EditingDocumentsResponse> {
  const params: {
    offset: number;
    limit: number;
    name?: string;
    memberId: string | null;
  } = { offset, limit, memberId };

  if (searchKeyword) {
    params.name = searchKeyword;
  }
  return requestApi<EditingDocumentsResponse>({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents`),
    method: 'GET',
    credentials: true,
    params,
  }).then((response) => response.data);
}

interface PostEditingDocumentsResponse {
  editingDocumentId: string;
}
/**
 * POST 편집 문서 생성
 */
export function postEditingDocuments(
  workspaceId: string,
  {
    fileId,
    name,
  }: {
    fileId: string;
    name: string;
  }
): Promise<PostEditingDocumentsResponse> {
  return requestApi<PostEditingDocumentsResponse>({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents`),
    method: 'POST',
    data: {
      fileId,
      name,
    },
    credentials: true,
  }).then((response) => response.data);
}
